"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnzerProvider = exports.UnzerContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useMultiSite = require("../pwa-kit/hooks/use-multi-site");
var _utils = require("../pwa-kit/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const UnzerContext = exports.UnzerContext = /*#__PURE__*/(0, _react.createContext)({
  unzerInstance: null,
  paymentInstance: null,
  setPaymentInstance: () => {},
  unzerPublicKey: ''
});
const UnzerProvider = ({
  children,
  unzerPublicKey
}) => {
  var _window2;
  const {
    locale
  } = (0, _useMultiSite.useMultiSite)();
  const [unzerInstance, setUnzerInstance] = (0, _react.useState)(null);
  const [paymentInstance, setPaymentInstance] = (0, _react.useState)(null);
  if (!_utils.isServer) (0, _react.useEffect)(() => {
    var _window;
    if (!unzerInstance && (_window = window) !== null && _window !== void 0 && _window.unzer) {
      const {
        unzer
      } = window;
      const unzerInstance = new unzer(unzerPublicKey, {
        locale: locale === null || locale === void 0 ? void 0 : locale.id
      });
      setUnzerInstance(unzerInstance);
    }
  }, [(_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.unzer]);
  return /*#__PURE__*/_react.default.createElement(UnzerContext.Provider, {
    value: {
      unzerInstance,
      setPaymentInstance,
      paymentInstance,
      unzerPublicKey
    }
  }, children);
};
exports.UnzerProvider = UnzerProvider;